import { get } from './requests.js'

export const getAudiences = () => get(`/custom-audiences`)
export const getFeeds = () => get(`/event-feeds`)
export const getInsights = () => get(`/report/all-last-updated`)

export const getRecentAudiences = (status, creator) =>
  get(
    `/custom-audiences?limit=10&q=&skip=0&sort=updated_at%2C-1${status ? `&status=${status}` : ''}${
      creator ? `&created_by.email=${decodeURIComponent(creator)}` : ''
    }`,
    { removeTrailingSlash: true }
  )

export const getEnumAudiences = () => get('/custom-audiences/enum/created_by.email')

export const getRecentInsights = () => get(`report/all-last-updated`, { removeTrailingSlash: true })

export const getRecentFeeds = (creator) =>
  get(
    `/event-feeds?fields=name&fields=deliveries.status&fields=client.name&fields=updated_at&limit=5&skip=0&sort=created_at%2C-1${
      creator ? `&created_by.email=${decodeURIComponent(creator)}` : ''
    }`,
    { removeTrailingSlash: true }
  )

export const getEnumDataFeeds = () => get('/event-feeds/enum/created_by.email')
